import React, {
  TextareaHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { useField } from '@unform/core';

import InputError from '../InputError';
import { Container } from './styles';

interface ITextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label?: string;
  containerStyle?: {};
  containerClassName?: string;
  required?: boolean;
}

const TextArea: React.FC<ITextAreaProps> = ({
  name,
  label,
  containerStyle = {},
  containerClassName,
  required = true,
  ...rest
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [isFocused, setIsFocused] = useState(false);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: textAreaRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      style={containerStyle}
      isErrored={!!error}
      isFocused={isFocused}
      className={`text-area${
        containerClassName ? ` ${containerClassName}` : ''
      }`}
    >
      {!!label && (
        <label
          htmlFor={name}
          className={`${required ? 'required' : ''}
        }`}
        >
          {label}
        </label>
      )}
      <textarea
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        ref={textAreaRef}
        {...rest}
      />

      {error && <InputError title={error} />}
    </Container>
  );
};

export default TextArea;
